export default "__VITE_ASSET__BPchfJwi__"